import { useNavigate } from "react-router-dom";
import suvidhaLogo from "../../assets/suvidhaLogo.png";
import backArrow from "../../assets/svg/backArrow.svg";
import "./index.css";

const Header = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <header className="header">
      <button className="back-button" onClick={handleBack} aria-label="Go back">
        <img src={backArrow} alt="back" className="back-button" />
      </button>
      <img src={suvidhaLogo} alt="Suvidha4u" className="header-logo" />

      <div className="header-text">Suvidha4U</div>
    </header>
  );
};

export default Header;
